/* ============================================================================
   CY TILE TILT (2026-09-30, split out of cy-pdp.js)
   The cursor model shared by the PDP tiles (step 1-3 cards, gallery thumbs, What's in the Box) and the mega-menu
   product cards: the conic glow points at the cursor, the shadow falls away, the tile tilts a few degrees.
   It lives here because the mega menu is on every page, while cy-pdp.js now loads on product pages only.
   Fine pointers only; touch never sees any of it. Styles: custom.css (mega cards) and cy-pdp.css (PDP tiles).
   ========================================================================== */
(function () {
  'use strict';
  if (window.CyTileTilt) return; window.CyTileTilt = true;
  /* The step-1 chair tiles, the step-2 delivery tiles and the step-3 bundle
     tiles carry the product card's cursor model: the conic glow arc points AT the cursor, the shadow falls
     AWAY from it, and the tile tilts a few degrees toward the pointer. Same
     maths as cy-product-card.js, minus the buy-bar hold — these tiles have no
     button to protect (the bundle's Change button sits outside its tile). The
     chair's own bundle tile is a label, not a control, and stays still. Fine
     pointers only; touch never sees any of it. */
  /* + the mega-menu product cards (2026-09-26, owner: 'same hover style'). This
     file loads on every page and these listeners are on the document, so the
     header cards get the identical tilt, cast shadow and glow. */
  /* + the PDP gallery thumbnails (2026-09-28, owner: 'gallery swatches need the same hover effects') */
  /* + the PDP What's in the Box cards (2026-09-28, owner: 'no 3d tilt like other cards'); product pages only */
  var TILE_SEL = '.cyp__opt, .cyp__pickrow, .cyp__kit:not(.cyp__kit--own), .cyp__addon, .cyg__thumb > .hdt-ratio, .hdt-page-type-product .cy-sys--hover.cy-sys--tiles .hdt-tcwi-inner,.cy-mega__card--pc > .cy-mega__card-link, .cy-mega__card--brand > .cy-mega__card-link, .cy-mega__card--viewall > .cy-mega__card-link';
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var tActive = null, tQueued = false, tx = 0, ty = 0;
    var TILT = Number((window.CY_SETTINGS || {}).cardTiltMax);
    if (!isFinite(TILT) || TILT <= 0) TILT = 6;
    var paintTile = function () {
      tQueued = false;
      if (!tActive) return;
      var r = tActive.getBoundingClientRect();
      if (!r.width) return;
      var dx = tx - (r.left + r.width / 2), dy = ty - (r.top + r.height / 2);
      var ang = (Math.atan2(dy, dx) * 180 / Math.PI + 90) + 'deg';
      tActive.style.setProperty('--cyo-glow', ang);
      /* mega product cards draw their arc on the LI around the link (custom.css, 2026-10-11: one outline over the border), so the
         angle goes there too: a custom property only reaches children */
      var host = tActive.parentElement; if (host && host.classList.contains('cy-mega__card--pc')) host.style.setProperty('--cyo-glow', ang);
      var nx = Math.max(-1, Math.min(1, dx / (r.width / 2)));
      var ny = Math.max(-1, Math.min(1, dy / (r.height / 2)));
      tActive.style.setProperty('--cyo-sx', (-nx * 14).toFixed(1) + 'px');
      tActive.style.setProperty('--cyo-sy', (-ny * 10).toFixed(1) + 'px');
      /* NO 3D TILT since 2026-10-05 (owner: "remove the 3D tilt from the mega menu and all other cards too" — mega-menu
         unlock for the tilt only): the tiles never rotate; the glow and the cast shadow above still follow the cursor. */
    };
    document.addEventListener('pointermove', function (e) {
      var t = e.target.closest && e.target.closest(TILE_SEL);
      if (!t) return;
      tActive = t; tx = e.clientX; ty = e.clientY;
      if (!tQueued) { tQueued = true; requestAnimationFrame(paintTile); }
    }, { passive: true });
    document.addEventListener('pointerleave', function (e) {
      var t = e.target;
      if (!(t && t.matches && t.matches(TILE_SEL))) return;
      t.style.transition = 'transform .35s var(--ease-out)';
      t.style.transform = '';
      t.style.removeProperty('--cyo-sx');
      t.style.removeProperty('--cyo-sy');
      if (tActive === t) tActive = null;
    }, true);
  }
})();
